import {
  Badge,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  MenuItem,
  Tooltip
} from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Icon from 'components/Icon'
import { type SubNavItemConfig } from 'components/navigation/Nav/use-gremlin-navigation'
import { muiTheme } from 'mui-theme'

export const SubNavItem: React.FC<{
  subNavItem: SubNavItemConfig
  handleClose(): void
}> = ({ subNavItem, handleClose }) => {
  if (subNavItem.isSectionHeader) {
    return (
      <ListSubheader
        disableSticky
        sx={{
          color: 'text.secondary',
          padding: '1 0.5',
          pb: 0,
          typography: 'overline'
        }}
      >
        {subNavItem.text}
      </ListSubheader>
    )
  }

  return (
    <Tooltip
      key={subNavItem.name}
      placement="right"
      title={
        subNavItem.showNotification
          ? 'Your team has a pending cluster access request'
          : ''
      }
    >
      <MenuItem
        component={RouterLink}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }}
        to={subNavItem.route}
        onClick={handleClose}
      >
        {subNavItem.icon && (
          <ListItemIcon
            sx={{
              justifyContent: 'center',
              color: subNavItem.disabled ? 'grey.600' : 'common.black'
            }}
          >
            <Icon
              css={[
                {
                  width: muiTheme.spacing(2.5),
                  height: muiTheme.spacing(2.5),
                  transition: 'opacity 150ms ease 0s'
                }
              ]}
              data-test-navigation-notification={subNavItem.showNotification}
              icon={subNavItem.icon}
            />
          </ListItemIcon>
        )}
        <ListItemText
          primary={subNavItem.text}
          primaryTypographyProps={{
            variant: 'body2'
          }}
        />
        {subNavItem.showNotification && (
          <ListItemIcon
            sx={{
              alignItems: 'center',
              justifyContent: 'flex-start'
            }}
          >
            <Badge
              badgeContent=""
              color="warning"
              sx={{
                left: (theme) => theme.spacing(2)
              }}
              variant="dot"
            />
          </ListItemIcon>
        )}
      </MenuItem>
    </Tooltip>
  )
}
